<div class="oase-lieferantenwechsel">
	<mat-card appearance="outlined">
		<mat-card-title>
			{{ OBJ_LNG_NAME+'.liste' | translate:locale.language }} <span *ngIf="dataSource" class="anzahl"> ({{ 'allgemein.daten.insgesamt' | translate:locale.language:{ count: dataSource.page.totalElements } }})</span>
			<p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>
			<p class="errors" *ngIf="fehlerMain" [innerHTML]="fehlerMain.messagehtml"></p>
		</mat-card-title>
		<mat-card-content>

			<div class="tabelle">
				<div class="tabelle-kopf" [style.display]="">
					<mat-form-field>
						<input matInput #filter>
						<mat-label>
							<i class="material-icons app-input-icon">search</i> {{ 'allgemein.suche' | translate:locale.language }}
						</mat-label>
						<button matSuffix mat-icon-button class="suche" (click)="clearFilter()" matTooltip="{{ 'allgemein.klick.leeresuche' | translate:locale.language }}"
								[disabled]="dataSource.isWaitingForResponse || filter.value == ''"><mat-icon>close</mat-icon></button>
					</mat-form-field>
				</div>

				<!-- Wenn eine Auswahl nicht benötigt wird einfach in displayedColumns die Spalte select nicht einbinden -->

				<div class="ladedaten" *ngIf="dataSource.isWaitingForResponse">
					<div>{{ 'allgemein.daten.laden.start' | translate:locale.language }} <mat-icon>free_breakfast</mat-icon></div>
					<div><mat-spinner color="primary"></mat-spinner></div>
					<div>{{ 'allgemein.daten.laden.ende' | translate:locale.language }}</div>
				</div>

				<mat-table #table [dataSource]="dataSource" matSort [style.display]="onDesktop()">

					<ng-container matColumnDef="lieferantennummer">
						<mat-header-cell *matHeaderCellDef fxFlex="17.42">{{ OBJ_LNG_NAME+'.lieferantennummer' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="17.42" *matCellDef="let row">

							{{ row.liefernummer }}

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="name">
						<mat-header-cell *matHeaderCellDef fxFlex="29.53">{{ OBJ_LNG_NAME+'.name' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="29.53" *matCellDef="let row">

							{{ row.name }}

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="adresse">
						<mat-header-cell *matHeaderCellDef fxFlex="41.74">{{ OBJ_LNG_NAME+'.adresse' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="41.74" *matCellDef="let row">

							{{ row.plz }} {{ row.ort }} {{ row.strasse }}

						</mat-cell>
					</ng-container>

					<!-- admin Column -->

					<ng-container matColumnDef="aktion">
						<mat-header-cell *matHeaderCellDef fxFlex="11.31">{{ OBJ_LNG_NAME+'.aktion' | translate:locale.language }}</mat-header-cell>
						<mat-cell *matCellDef="let row" fxFlex="11.31">

							<a class="shorten-long-text" mat-raised-button (click)="wechsleLieferant(row)" target="_blank">{{ OBJ_LNG_NAME+'.wechseln' | translate:locale.language }}</a>
<!--							<button mat-icon-button (click)="zeigeBearbeitenMaske(row)" matTooltip="{{ 'allgemein.klick.bearbeiten' | translate:locale.language:{ bestimmt: OBJ_LNG_NAME + '.artikel.bestimmt' | translate:locale.language, typ: OBJ_LNG_NAME + '.typ' | translate:locale.language } }}"><mat-icon>edit</mat-icon></button>-->
<!--							<button mat-icon-button (click)="zeigeLoeschenMaske(row)" matTooltip="{{ 'allgemein.klick.löschen' | translate:locale.language:{ bestimmt: OBJ_LNG_NAME + '.artikel.bestimmt' | translate:locale.language, typ: OBJ_LNG_NAME + '.typ' | translate:locale.language } }}"><mat-icon>delete</mat-icon></button>-->

						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns; let i = index;" ></mat-row>

				</mat-table>

				<div class="sucheleer" [style.display]="dataSource.page.totalElements > 0 && dataSource.page.searchElements == 0 ? '' : 'none'">
					{{ 'allgemein.daten.sucheleer' | translate:locale.language }}
				</div>

				<div class="keinedaten" [style.display]="dataSource.page.totalElements == 0 ? '' : 'none'">
					{{ 'allgemein.daten.keine' | translate:locale.language }}
				</div>

				<mat-paginator #paginator [class.hide]="dataSource.page.searchElements <= dataSource.page.size"
							   [length]="dataSource.page.searchElements"
							   [pageIndex]="0"
							   [pageSize]="10"
							   [pageSizeOptions]="[5,10,15,20,25,30,50,100,200,500]">
				</mat-paginator>
			</div>
		</mat-card-content>
	</mat-card>

	<div [style.display]="onMobile()" class="mobile">
		<mat-card appearance="outlined" *ngFor="let lieferant of dataSource.content">
			<mat-card-title>
				{{ OBJ_LNG_NAME+'.lieferantennummer' | translate:locale.language }} : {{ lieferant.liefernummer }}
			</mat-card-title>
			<mat-card-subtitle>
				{{ OBJ_LNG_NAME+'.name' | translate:locale.language }} : {{ lieferant.name }}
			</mat-card-subtitle>
			<mat-card-content>
				{{ OBJ_LNG_NAME+'.adresse' | translate:locale.language }} : {{ lieferant.plz }} {{ lieferant.ort }} {{ lieferant.strasse }}
			</mat-card-content>
			<mat-card-actions align="end">
				<a class="shorten-long-text" mat-raised-button (click)="wechsleLieferant(lieferant)" target="_blank">{{ OBJ_LNG_NAME+'.wechseln' | translate:locale.language }}</a>
			</mat-card-actions>
		</mat-card>

	</div>

</div>

<!-- add button -->

<!--<div class="globalbuttons">-->
<!--	<button *ngIf="!dataSource.isWaitingForResponse" mat-fab class="pull-right" type="button" matTooltip="{{ 'allgemein.klick.hinzufügen' | translate:locale.language:{ unbestimmt: OBJ_LNG_NAME+'.artikel.unbestimmt' | translate:locale.language, typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}" matTooltipPosition="above"-->
<!--			(click)="zeigeHinzufuegenMaske()"><mat-icon>add</mat-icon></button>-->
<!--</div>-->



<!--<div class="oase-lieferantenwechsel">-->
<!--    <mat-card *ngIf="media.isActive('gt-sm')">-->
<!--        <mat-card-title>-->
<!--            {{ OBJ_LNG_NAME+'.liste' | translate:locale.language }}<span *ngIf="data" class="anzahl"> ({{ 'allgemein.daten.insgesamt' | translate:locale.language:{ count: data.length } }})</span>-->
<!--            <p class="errors" *ngIf="fehlerMain" [innerHTML]="fehlerMain.messagehtml"></p>-->
<!--        </mat-card-title>-->
<!--        <mat-card-content>-->
<!--            <table class="table table-striped" [md2Data]="data | dataPipeLieferantenwechsel:search" #md2="md2DataTable" [rowsPerPage]="12" [sortBy]="createDate">-->

<!--                <thead>-->
<!--                    <tr *ngIf="!ladedaten && (md2.data.length > 0 || search != '')">-->
<!--                        <td colspan="4" class="suche">-->
<!--                            <mat-form-field class="full-width tabellesuche">-->
<!--                                <input matInput class="md2-input" [(ngModel)]="search" />-->
<!--                                <mat-placeholder>-->
<!--                                    <i class="material-icons app-input-icon">search</i> {{ 'allgemein.suche' | translate:locale.language }}-->
<!--                                </mat-placeholder>-->
<!--                            </mat-form-field>-->
<!--                            <button mat-icon-button class="tabellesuchebtn" (click)="search=''" matTooltip="{{ 'allgemein.klick.leeresuche' | translate:locale.language }}" [disabled]="ladedaten || dialogrunningajaxcall || search == ''"><mat-icon>close</mat-icon></button>-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                        <th class="center">{{ OBJ_LNG_NAME+'.lieferantennummer' | translate:locale.language }}</th>-->
<!--                        <th class="center">{{ OBJ_LNG_NAME+'.name' | translate:locale.language }}</th>-->
<!--                        <th class="center">{{ OBJ_LNG_NAME+'.adresse' | translate:locale.language }}</th>-->
<!--                        <th class="center">{{ OBJ_LNG_NAME+'.aktion' | translate:locale.language }}</th>-->
<!--                    </tr>-->
<!--                </thead>-->
<!--                <tbody>-->
<!--                    <tr *ngIf="ladedaten" class="ladedaten">-->
<!--                        <td colspan="4" class="center">-->
<!--                            {{ 'allgemein.daten.laden.start' | translate:locale.language }}-->
<!--                            <mat-icon>hourglass_empty</mat-icon>-->
<!--                            <mat-spinner color="accent"></mat-spinner>-->
<!--                            {{ 'allgemein.daten.laden.ende' | translate:locale.language }}-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                    <tr *ngIf="!ladedaten && md2.data.length == 0" class="keinedaten">-->
<!--                        <td colspan="4" class="center">{{ (search == '' ? 'allgemein.daten.keine' : 'allgemein.daten.sucheleer')  | translate:locale.language }}</td>-->
<!--                    </tr>-->
<!--                    <tr *ngFor="let lieferant of md2.data" >-->
<!--                        <td class="center">{{ lieferant.liefernummer }}</td>-->
<!--                        <td class="center">{{ lieferant.name }}</td>-->
<!--                        <td class="center">{{ lieferant.plz }} {{ lieferant.ort }} {{ lieferant.strasse }}</td>-->
<!--                        <td class="center"><a class="shorten-long-text" mat-raised-button (click)="wechsleLieferant(lieferant)" target="_blank">{{ OBJ_LNG_NAME+'.wechseln' | translate:locale.language }}</a></td>-->
<!--                    </tr>-->
<!--                </tbody>-->
<!--                <tfoot>-->
<!--                    <tr>-->
<!--                        <td colspan="4">-->
<!--                            <md2-pagination [rowsPerPageSet]="[5,10,12,15,20,25,30,50,100,200,500]"></md2-pagination>-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                </tfoot>-->
<!--            </table>-->
<!--        </mat-card-content>-->
<!--    </mat-card>-->
<!--    <mat-card *ngIf="!media.isActive('gt-sm')">-->
<!--        <mat-card-title>-->
<!--            {{ OBJ_LNG_NAME+'.liste' | translate:locale.language }}<span *ngIf="data" class="anzahl"> ({{ 'allgemein.daten.insgesamt' | translate:locale.language:{ count: data.length } }})</span>-->
<!--            <p class="errors" *ngIf="fehlerMain" [innerHTML]="fehlerMain.messagehtml"></p>-->
<!--        </mat-card-title>-->
<!--        <mat-card-subtitle *ngIf="!ladedaten && data.length == 0">-->
<!--            {{ (search == '' ? 'allgemein.daten.keine' : 'allgemein.daten.sucheleer')  | translate:locale.language }}-->
<!--        </mat-card-subtitle>-->
<!--        <mat-card-content *ngIf="ladedaten">-->
<!--            {{ 'allgemein.daten.laden.start' | translate:locale.language }}-->
<!--            <mat-icon>hourglass_empty</mat-icon>-->
<!--            <mat-spinner color="accent"></mat-spinner>-->
<!--            {{ 'allgemein.daten.laden.ende' | translate:locale.language }}-->
<!--        </mat-card-content>-->
<!--        <mat-card-content *ngIf="!ladedaten && (data.length > 0 || search != '')">-->
<!--            <mat-form-field class="full-width tabellesuche">-->
<!--                <input matInput class="md2-input" [(ngModel)]="search" />-->
<!--                <mat-placeholder>-->
<!--                    <i class="material-icons app-input-icon">search</i> {{ 'allgemein.suche' | translate:locale.language }}-->
<!--                </mat-placeholder>-->
<!--            </mat-form-field>-->
<!--            <button mat-icon-button class="tabellesuchebtn" (click)="search=''" matTooltip="{{ 'allgemein.klick.leeresuche' | translate:locale.language }}" [disabled]="ladedaten || dialogrunningajaxcall || search == ''"><mat-icon>close</mat-icon></button>-->
<!--        </mat-card-content>-->
<!--    </mat-card>-->
<!--    <ng-container *ngIf="!media.isActive('gt-sm')">-->
<!--        <mat-card *ngFor="let eintrag of data | dataPipeKategorieeintrag:search">-->
<!--            <mat-card-title>-->

<!--            </mat-card-title>-->
<!--            <mat-card-subtitle>-->
<!--            </mat-card-subtitle>-->
<!--            <mat-card-content>-->
<!--                {{ eintrag.text }} <br /><br />-->
<!--                <span *ngIf="eintrag.anhang != null" style="color: rgba(0, 0, 0, 0.54); font-size:12px;">{{ 'allgemein.download' | translate:locale.language }}</span>-->
<!--                <a class="eintrag_download_button shorten-long-text" *ngFor="let anhang of eintrag.anhang" mat-raised-button (click)="eintrag.betrachtet || setBetrachtet(eintrag)" [href]="authService.getAuthUrl(REST_API_BASE+anhang.download)" matTooltip="{{ 'allgemein.download' | translate:locale.language }}" target="_blank">{{anhang.name}}</a>-->
<!--            </mat-card-content>-->
<!--            <mat-card-actions align="end">-->
<!--                <button mat-raised-button [ngClass]="{'accent-bg' : !eintrag.betrachtet}" *ngIf="!eintrag.betrachtet" (click)="setBetrachtet(eintrag)">{{ OBJ_LNG_NAME+'.gelesen' | translate:locale.language}}</button>-->
<!--                <div *ngIf="eintrag.betrachtet"><span style="color: rgba(0, 0, 0, 0.54); font-size:12px;">{{ OBJ_LNG_NAME+'.eintragGelesen' | translate:locale.language }}</span><mat-icon >check</mat-icon></div>-->
<!--            </mat-card-actions>-->
<!--        </mat-card>-->
<!--    </ng-container>-->
<!--</div>-->
